


















import { defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import CLocationAutocompleteInput from '~/components/shared/configurable/location/CLocationAutocompleteInput.vue'
import { GeocodingSearchLocation } from '~/models/location/geocoding'
import { createSearchGeolocationString } from '~/utils/geolocation'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'

export default defineComponent({
  components: { CLocationAutocompleteInput },
  props: facetHandlerComponentProps,
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()

    const geolocations = ref<GeocodingSearchLocation[]>(
      props.selected?.geolocations || []
    )

    watch(
      () => props.selected,
      newSelected => {
        geolocations.value = newSelected?.geolocations || []
      }
    )

    function onClear() {
      geolocations.value = []

      changeParams([
        {
          name: 'rich-geolocation',
          value: []
        }
      ])
    }

    function onLocationsChange(locations: GeocodingSearchLocation[]) {
      changeParams([
        {
          name: 'rich-geolocation',
          value: locations.map(createSearchGeolocationString)
        }
      ])
    }

    return { geolocations, onClear, onLocationsChange }
  }
})
